module.exports = __webpack_public_path__ + "static/media/logoRegisBlanco.06608795.png";